<!-- Solo ícono: sin caja en reposo; el tooltip y el nombre accesible dicen qué PDF abre. -->
<button
  type="button"
  class="pdf-icon-btn"
  [disabled]="disabled"
  [attr.aria-busy]="opening || null"
  [attr.aria-label]="ariaLabel"
  [pTooltip]="label"
  [tooltipDisabled]="opening"
  tooltipPosition="top"
  (click)="open.emit()"
>
  <i class="fa-solid" [ngClass]="opening ? 'fa-circle-notch fa-spin' : 'fa-file-pdf pdf-icon-btn__icon'" aria-hidden="true"></i>
</button>
